import React from 'react'
import SectionHeading from "./../../utilities/SectionHeading"
import "./About.css"
import { Link } from "react-scroll"

export default function About() {
    return (
        <div>
            <section id="About" data-aos="fade-in">
                <SectionHeading heading="About Me" description="Let's tell you something about myself" />

                <div className="about-container" data-aos="fade-out">
                    <div className="about-box">

                        <div className="aboutDP-box" data-aos="fade-in" >
                            <div className="aboutDP">

                            </div>
                        </div>

                        <div className="desc-box" data-aos="fade-in">
                            <div className="desc">
                                Hello! I'm <span id="myName"> Arindam </span>, an aspiring Software Engineer and an <span id="myDept"> IT </span> Undergrad in <span id="myCollege">Jadavpur University</span>, based in Kolkata, India. I am always willing and dedicated to learn new things and keep myself updated with the advancements happening around me.

                                <br /><br />
                                There are lots of hobbies I do in my leisure time like watching movies, listening songs, learn new things from the internet, play games, photography, performing magic. I always try to see things in unique ways. I love challenges.. I did many projects and faced lots of problems ...some are solved and for some, I am still finding the solutions.

                                <br /><br />
                                Wanna know more about me ??... Okay <Link smooth={true} to="Resume" duration={1000}><p className='goNext'> See Next </p></Link>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    )
}
